import React from 'react';

import {isFullUTFlexibilityEnabled} from 'modbio/util';
import {BaseFilterFormProps, FilterStyle} from 'search/filters/base/FilterFormConstants';
import SingleValueDropdownFilterForm from 'search/filters/base/SingleValueDropdownFilterForm';
import TextValueFilterForm from 'search/filters/base/TextValueFilterForm';
import {filterHasMixedBaseValue} from 'search/filters/validateResiduesFilters';
import {FilterKey, GenericFilter, Operator, OPERATOR_TO_TEXT} from 'search/SearchConstants';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import insertTextFromPaste from 'util/insertTextFromPaste';

interface Props extends BaseFilterFormProps {
  filter: GenericFilter<FilterKey.SEQUENCE_BASES>;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: GenericFilter<FilterKey.SEQUENCE_BASES>) => void;
  onRemove?: () => void;
  operators: Array<Operator>;
}

export default function SequenceBasesFilterForm(props: Props): JSX.Element {
  if ([Operator.INCLUDES_TEXT, Operator.IS].includes(props.filter.operator)) {
    return (
      <>
        <TextValueFilterForm
          {...props}
          filterStyle={props.filterStyle}
          onChangeValue={(value: string) => {
            props.onChangeFilter({
              ...props.filter,
              value,
            });
          }}
          onChangeOperator={(operator: Operator) => {
            props.onChangeFilter({
              ...props.filter,
              value: props.filter.value ?? '',
              operator,
            });
          }}
          onPaste={insertTextFromPaste}
          onRemove={props.onRemove}
          operators={props.operators}
          selectedOperator={props.filter.operator}
          initialValue={props.filter.value ?? ''}
        />
        {isFullUTFlexibilityEnabled() && filterHasMixedBaseValue(props.filter) && (
          <div className="u-tiny-spacing-top u-spacing-right">
            <InlineBanner
              bannerType={InlineBannerType.INFO}
              hideIcon={true}
              supportingInfo="Mixed bases queries will return all results matching either U or T for each U/T in the query."
            />
          </div>
        )}
      </>
    );
  }
  return (
    <SingleValueDropdownFilterForm
      {...props}
      filterStyle={props.filterStyle}
      optionDatas={props.operators.map((op) => ({
        name: OPERATOR_TO_TEXT[op],
        value: op,
      }))}
      value={Operator.IS_EMPTY}
      onChangeValue={(operator: string) => {
        props.onChangeFilter({
          ...props.filter,
          operator: operator as Operator,
        });
      }}
    />
  );
}
